import { Directive, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from 'src/app/_services/document.service';
import { ProposalService } from 'src/app/_services/proposal.service';
import { CancellationMetadata } from 'src/app/_types/lead.types';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { getTransmissionMethodLabel } from 'src/app/enums/cancellation/transmission-method.enum';
import { getInsuranceTypeLabel } from 'src/app/enums/insurance-type.enum';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class CancellationMetadataComponentAbstract
  extends BaseMetadataComponent<CancellationMetadata>
  implements OnInit
{
  policyLink!: string;

  proposalDetails!: ProposalDetails;

  constructor(
    proposalService: ProposalService,
    private readonly documentService: DocumentService
  ) {
    super(proposalService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.metadata.policyProposalId) {
      this.proposalService
        ._getPartnerProposalDetails({
          proposalId: this.metadata.policyProposalId,
        })
        .subscribe({
          next: (x: any) => {
            this.proposalDetails = x.data;
            this.policyLink = `/proposal/view/${this.proposalDetails.proposalId}`;
          },
        });
    }
  }

  getInsuranceTypeLabel = getInsuranceTypeLabel;

  getTransmissionMethodLabel = getTransmissionMethodLabel;

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  viewFile(key: string) {
    this.documentService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
